import { FinanceValueObjectsFinancialDocumentTypeEnum } from 'generated/resources/graphql'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

interface SelectorProps {
  selectedDocumentType?: FinanceValueObjectsFinancialDocumentTypeEnum
  error?: string
  readOnly: boolean
  onSelectDocumentTypeSelector: (selected?: FinanceValueObjectsFinancialDocumentTypeEnum) => void
}

export const DocumentTypeSelector = ({
  selectedDocumentType,
  error,
  readOnly,
  onSelectDocumentTypeSelector,
}: SelectorProps) => {
  const options: { value: FinanceValueObjectsFinancialDocumentTypeEnum; label: string }[] = [
    {
      value: 'invoice',
      label: i18n.t('finance.invoices.detail.document_type.invoice'),
    },
    {
      value: 'credit_note',
      label: i18n.t('finance.invoices.detail.document_type.credit_note'),
    },
  ]

  const handleOnChange = (value: string) => {
    onSelectDocumentTypeSelector(options.find((option) => option.value === value)?.value)
  }

  return (
    <Select
      readonly={readOnly}
      mandatory
      label={i18n.t('finance.invoices.detail.fields.document_type')}
      options={options}
      onChange={handleOnChange}
      value={selectedDocumentType ? selectedDocumentType : 'invoice'}
      error={error}
    />
  )
}
